import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { Store } from '@sama/app-state';
import { ToolsHelperService } from '../../../../../cross-team-shared/misc-services/tools-helper.service';
import { DEFAULT_OPACITY } from '../../../../../cross-team-shared/state/layer-settings-state-2d';
import { shellConnectorToken } from '../../../../../team-apis/core/shell-connector';
import { AbstractSensorContentStore2D } from '../../../state/abstract-sensor-content-store-2d';

@Component({
  selector: 'h3-vector-tagging-layer-view-settings-popover',
  styleUrls: ['./vector-tagging-layer-view-settings-popover.component.scss'],
  templateUrl: './vector-tagging-layer-view-settings-popover.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class VectorTaggingLayerViewSettingsPopoverComponent implements OnInit {
  @Input({ required: true }) isOrthographic!: boolean;

  isRectangleToolAllowed!: boolean;

  showShapeDimensionsStore!: Store<boolean>;
  hideOccludedShapesStore!: Store<boolean>;
  alwaysShowSubpointsStore!: Store<boolean>;
  swapLayerOnSelectStore!: Store<boolean>;
  defaultLayerOpacity = DEFAULT_OPACITY;

  private store = inject(AbstractSensorContentStore2D);
  private shellConnector = inject(shellConnectorToken);
  private toolsHelperService = inject(ToolsHelperService);

  ngOnInit() {
    this.assignStores();

    const allowedTools = this.toolsHelperService.getAllowedTools(
      this.store.state().output.name,
    );

    this.isRectangleToolAllowed =
      allowedTools.includes('Rectangle') ||
      allowedTools.includes('SliderRectangle');
  }

  trackShowDimensionsChange() {
    this.shellConnector.trackEvent({
      id: 'toggle_show_rectangle_dimensions',
      bucket: 'navigation',
      sub_bucket: 'frame',
      new_value: this.showShapeDimensionsStore.state(),
    });
  }

  trackHideOccludedShapesChange() {
    this.shellConnector.trackEvent({
      id: 'toggle_hide_occluded_shapes',
      bucket: 'navigation',
      sub_bucket: 'frame',
      new_value: this.hideOccludedShapesStore.state(),
    });
  }

  private assignStores() {
    this.showShapeDimensionsStore = this.store('layerSettings')(
      'showShapeDimensions',
    );
    this.hideOccludedShapesStore =
      this.store('layerSettings')('hideOccludedShapes');
    this.alwaysShowSubpointsStore = this.store('layerSettings')(
      'alwaysShowSubpoints',
    );
    this.swapLayerOnSelectStore =
      this.store('layerSettings')('swapLayerOnSelect');
  }
}
